import { Mail } from 'lucide-react';
import Button from '@/components/elements/Button';
import { useNavigate } from 'react-router-dom';
import { mergeClassName } from '@/utils/mergeClassName';
import { trackCustomEvent } from '@/lib/appInsights';
import { TrackingCustomEvents } from '@/constants/constants';

interface ContactButtonProps {
  className?: string;
  variant?: 'hollow' | 'gradient' | 'disabled' | 'faded' | 'icon' | undefined;
}

function ContactButton({ className, variant }: ContactButtonProps) {
  const navigate = useNavigate();

  function navigateToContactPage() {
    navigate('/contact');
    trackButtonClick();
  }

  function trackButtonClick() {
    trackCustomEvent(TrackingCustomEvents.click.cta.contactUs, {
      page: window.location.pathname,
    });
  }

  return (
    <Button
      variant={variant}
      onClick={navigateToContactPage}
      className={mergeClassName(['flex items-center gap-2', className])}
    >
      Contact Us <Mail size={16} className='mb-[1px]' />
    </Button>
  );
}

export default ContactButton;
